import { DeliveryConfiguration } from '../../../@types/model/deliveryConfiguration';
import { useEffect, useState } from 'react';
import { DeliveryRequestItem } from '../../../@types/model/deliveryRequest';
import BarDeliver from './pieces/BarDeliver';
import generateSlotsOccupiedGrouped, {
  FusionDeliveryRequestItem
} from './functions/generateSlotsOccupiedGrouped';
import { Tooltip } from '@mui/material';
import { ProductType } from '../../../@types/model/productType';
import { useRecoilValue } from 'recoil';
import { productTypeState } from 'recoil/productTypeState';

type DeliveryBarProps = {
  totalTruck: number;
  max: number;
  slot_amount: number;
  unit: string;
  deliveryRequestItems: DeliveryRequestItem[];
  deliveryConfiguration: DeliveryConfiguration | null;
};

const DeliveryBarTruckSilos = (props: DeliveryBarProps) => {
  const [totalTruck, setTotalTruck] = useState<number>(0);
  const [totalTruckCapacity, setTotalTruckCapacity] = useState<number>(0);
  const [slotsOccupied, setSlotsOccupied] = useState<FusionDeliveryRequestItem[]>([]);
  const productTypes: ProductType[] = useRecoilValue(productTypeState);
  useEffect(() => {
    let total = 0;
    props.deliveryRequestItems.forEach((sri: DeliveryRequestItem) => {
      total += sri.quantity;
    });
    setTotalTruck(total);
    setTotalTruckCapacity(
      (props.deliveryConfiguration?.configuration.max ?? 0) *
        (props.deliveryConfiguration?.configuration.slot_amount ?? 0)
    );
  });
  useEffect(() => {
    if (props.deliveryConfiguration) {
      setSlotsOccupied(
        generateSlotsOccupiedGrouped(props.deliveryRequestItems, props.deliveryConfiguration, null)
      );
    }
  }, [props]);
  return (
    <BarDeliver className="barDeliver">
      {props.deliveryConfiguration ? (
        <div className="deliveryBarTruck">
          <div className="slotsInTruck">
            {slotsOccupied.map((slot: FusionDeliveryRequestItem, index: number) => {
              return (
                <Tooltip
                  title={
                    slot.quantity +
                    ' ' +
                    props.deliveryConfiguration?.units +
                    ' ' +
                    productTypes.find((pt) => pt.guid === slot.product)?.name
                  }
                  key={index}
                >
                  <div
                    className="slot"
                    style={{
                      width: 100 / slotsOccupied.length + '%'
                      // ((props.deliveryConfiguration?.configuration.slot_amount ?? 0) /
                      //   totalTruckCapacity) *
                      //   100 +
                      // '%'
                    }}
                  >
                    <div
                      className="slotFilled"
                      style={{
                        width:
                          (slot.quantity /
                            (props.deliveryConfiguration?.configuration.slot_amount ?? 0)) *
                            100 +
                          '%'
                      }}
                    ></div>
                  </div>
                </Tooltip>
              );
            })}
          </div>
          <label className="label">{totalTruck + props.unit}</label>
        </div>
      ) : null}
    </BarDeliver>
  );
};
export default DeliveryBarTruckSilos;
